export default __webpack_public_path__ + "static/purple-gradient-with-dark-transition-5d99f8b4fec03d7f9121d89bc3cb5790.webp";